import AvatarRing from "./AvatarRing";
import MoveIcon from "./MoveIcon";
import Logo from "./Logo";
import { GRADIENT_BG, TEXT_MUTED, TEXT_DARK } from "../theme";

function ShareableResultCard({ userProfile, opponentProfile, myMove, opponentMove, myScore, opponentScore, outcomeText, outcomeColors, borderItem, opponentBorderItem }) {
  return (
    <div style={{ background: GRADIENT_BG, borderRadius: "16px", padding: "28px 22px", textAlign: "center", width: "100%", maxWidth: "380px" }}>
      <div style={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
        <Logo size={20} />
      </div>

      <div style={{ display: "flex", justifyContent: "space-around", alignItems: "flex-start", marginBottom: "20px" }}>
        <ResultAvatar
          photoURL={userProfile.photoURL}
          displayName={userProfile.displayName}
          subtitleItem={null}
          move={myMove}
          borderItem={borderItem}
          label="you"
        />
        <div style={{ fontSize: "0.75rem", color: TEXT_MUTED, fontWeight: "600", paddingTop: "36px" }}>vs</div>
        <ResultAvatar
          photoURL={opponentProfile.photoURL}
          displayName={opponentProfile.displayName}
          subtitleItem={null}
          move={opponentMove}
          borderItem={opponentBorderItem}
          flip={opponentMove === "defect"}
          label="them"
        />
      </div>

      <div style={{ marginBottom: "18px" }}>
        <span style={{ display: "inline-block", padding: "9px 22px", borderRadius: "20px", background: outcomeColors.bg, color: outcomeColors.color, fontSize: "0.9375rem", fontWeight: "700" }}>
          {outcomeText}
        </span>
      </div>

      <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
        <div style={{ flex: 1, textAlign: "center", padding: "14px", borderRadius: "10px", background: "rgba(255,255,255,0.6)" }}>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED, marginBottom: "4px" }}>you</div>
          <div style={{ fontSize: "1.625rem", fontWeight: "700", color: TEXT_DARK }}>+{myScore}</div>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED }}>total {userProfile.totalScore || 0}</div>
        </div>
        <div style={{ flex: 1, textAlign: "center", padding: "14px", borderRadius: "10px", background: "rgba(255,255,255,0.6)" }}>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED, marginBottom: "4px" }}>them</div>
          <div style={{ fontSize: "1.625rem", fontWeight: "700", color: TEXT_DARK }}>+{opponentScore}</div>
          <div style={{ fontSize: "0.6875rem", color: TEXT_MUTED }}>total {opponentProfile.totalScore || 0}</div>
        </div>
      </div>

      <div style={{ fontSize: "0.75rem", color: TEXT_MUTED, fontWeight: "600" }}>play at trustgame.co.uk</div>
    </div>
  );
}

function ResultAvatar({ photoURL, displayName, move, borderItem, flip = false, label }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", width: "100px" }}>
      <div style={{ position: "relative", width: "84px", height: "84px" }}>
        <AvatarRing photoURL={photoURL} size={84} item={borderItem} fallbackBorder="3px solid #d8dae3" />
        <div style={{ position: "absolute", bottom: "-8px", right: "-8px", background: "#fff", borderRadius: "50%", padding: "7px", boxShadow: "0 2px 6px rgba(0,0,0,0.15)" }}>
          <MoveIcon move={move} size={22} flip={flip} />
        </div>
      </div>
      <div style={{ fontSize: "0.6875rem", fontWeight: "700", color: TEXT_DARK, marginTop: "10px", textAlign: "center", maxWidth: "90px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {displayName || label}
      </div>
    </div>
  );
}

export default ShareableResultCard;
